import { isUndefined } from 'lodash';
import React, { useEffect } from 'react';
import { DocumentRevisionFormState, DocumentRevisionSummaryProps, SM, SMProvider } from '../../..';
import { openPOToastr } from '../../../../ui/components/notifications/POStatus';
import { checkIsDocumentPO, checkIsDocumentReceivable } from '../../../../ui/documentRevision/helpers/checkDocumentGroup';
import { FB, FBPOApprovalsState, FBProcedureCatalogState, FBProvider, FBSerialsState } from '../../../../ui/form.builder';

export const withDocumentRevisionSummaryWrap = <T extends DocumentRevisionSummaryProps>(
  Component: React.FC<T>,
): React.FC<T> => {
  const Comp = ({
    _documentRevisionFormState,
    documentRevision,
    isFB,
    ...props
  }: T) => {
    // MARK: @config
    _documentRevisionFormState = SM.useRef(DocumentRevisionFormState);
    const { _tabsState, _formState } = SM.useStores();
    _documentRevisionFormState?.setDocumentRevision(documentRevision);
    const { formInput, formTemplate, formDocument } = documentRevision || {};
    let { schema } = formTemplate || formDocument?.formTemplate || {};
    schema = documentRevision.schema || schema;
    const formFB = formInput || formTemplate || formDocument;
    isFB = !isUndefined(formFB);

    const isPO = checkIsDocumentPO(documentRevision?.document.documentType.groupOptions);
    const isReceivable = checkIsDocumentReceivable(documentRevision?.document?.documentType?.groupOptions);
    const poApprovalsState = isPO ? FB.useRef(
      FBPOApprovalsState,
      {
        id: documentRevision.id,
        approvals: documentRevision?.approvals,
      },
    ) : undefined;

    const serialsState = FB.useRef<FBSerialsState>(FBSerialsState, documentRevision);
    const procedureCatalogState = FB.useRef<FBProcedureCatalogState>(FBProcedureCatalogState);

    // MARK: @state
    useEffect(() => {
      const reOpenedPOInfo = localStorage.getItem('reOpenedPOInfo');
      if (isReceivable && reOpenedPOInfo) {
        try {
          openPOToastr(JSON.parse(reOpenedPOInfo));
        } catch {}
        localStorage.removeItem('reOpenedPOInfo');
      }
      _formState?.setMode('preview');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <SMProvider {...{ _documentRevisionFormState }}>
        <FBProvider {...{ poApprovalsState, serialsState, procedureCatalogState }}>
          <Component
            {...props as T}
            {...{
              _documentRevisionFormState,
              _tabsState,
              _formState,
              documentRevision,
              schema,
              isFB,
            }}
          />
        </FBProvider>
      </SMProvider>
    );
  };

  Comp.displayName = 'withDocumentRevisionSummaryWrap';
  return (props: T) => Comp(props);
};
